<template>
  <el-cascader
    ref="cascader"
    class="AProductTypeSelector"    
    v-model="val"
    clearable
    :options="options"
    :props="props"
    :placeholder="placeholder"
    @change="handleChange"
    />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AProductTypeSelector",
  data() {
    return {
      val: undefined,
      props: {
        value: 'id',
        label: 'name',
        checkStrictly: true,
      },
    };
  },
  props: {
    value: Number,
    limitSecondLevel: {
      type: Boolean,
      default: false
    },
    placeholder: String,
  },
  watch: {
    value: function(newVal) {
      if (!newVal) {
        this.val = [];
        return;
      }
      let parent = this.table_product_type.find(c => c.id === newVal);
      let value = []
      if (!parent) {
        this.val = [newVal];
        return;
      }
      let target = Object.assign({}, parent)
      while(target.parent_id) {
        let parent2 = this.table_product_type.find(c => c.id === target.parent_id);
        if (parent2) {
          value.splice(0, 0, parent2.id);
          target = parent2;
        }
      }
      value.push(parent.id);
      this.val = value;
    }
  },  
  created() {   
    this.val = this.value
  },
  computed: {
    ...mapGetters(["table_product_type"]),
    options: function() {      
      let options = this.system.organizeProductType(this.table_product_type, this.limitSecondLevel);
      options.sort(this.util.sortDescByName);
      options.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.children.sort(this.util.sortDescByName);
        }
      });
      return options;
    },
  },  
  methods: {
    handleChange(value) {
      this.$refs.cascader.toggleDropDownVisible(false);
      let val = value.length > 0 ? this.val[this.val.length - 1] : null;
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
};
</script>
